<template>
  <div style="display: flex; flex-direction: column; gap:5px">
    <div class="card p-3 bg-light" v-for="(dataPerent, index) in data || []" :key="index">
      <div class="mb-2">
         <Content title="Tên người gửi" :content="dataPerent?.senderName"></Content>
         <Content title="Mã theo dõi" :content="dataPerent?.trackingCode"></Content>
         <Content title="Ghi chú" :content="dataPerent?.notes"></Content>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Tên thiết bị</th>
            <th scope="col">serial</th>
            <th scope="col">Mã thiết bị</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="dataPerent?.devices || []">
            <tr v-for="(item, index) in dataPerent.devices" :key="index">
              <td>
                {{ item.deviceName }}
              </td>
              <td>
                {{ item.serial }}

              </td>
              <td>
                {{ item.deviceCode }}
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="5">
                <div class="text-center text-muted">
                  {{ isLoading ? 'Đã lấy dữ liệu...' : 'Không có dữ liệu' }}
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import Content from '@/components/common/Content.vue'

export default {
  name: 'deviceShipments',
  components: { Content },

  props: {
    data: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="css" scoped>
.table {
  thead {
    tr {
      background: #DDD;
      border: 1px solid #CCC;

      th {
        font-weight: 600;
        color: #0b62ab;
        border-left: 1px solid #CCC;

        &:first-child {
          border-left: none;
        }
      }
    }
  }

  tbody {
    tr {
      td {
        ul {
          padding-left: 0;

          li {
            display: inline-block;
            border: 1px solid #DDD;
            width: 80px;
            height: 60px;
            overflow-y: hidden;

            a {
              img {
                width: 80px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
